// Lazy Intercom bootstrap. The messenger SDK blocks the main thread for ~600ms and keeps a
// WebSocket open (which also disqualifies pages from the back/forward cache), so it must never
// load eagerly: callers boot it on the first real user interaction or on demand via showIntercom.
const INTERCOM_APP_ID = 'ikdya8x6';

type IntercomCommand = (command: string, ...args: unknown[]) => void;
type IntercomWindow = Window & { Intercom?: IntercomCommand };

let bootPromise: Promise<void> | null = null;

export function bootIntercom(language: string): Promise<void> {
  if (!bootPromise) {
    bootPromise = import('@intercom/messenger-js-sdk').then(({ default: Intercom }) => {
      Intercom({ app_id: INTERCOM_APP_ID, background_color: '#aef55c', action_color: '#aef55c', language_override: language });
    });
  }
  return bootPromise;
}

export function isIntercomBooted(): boolean {
  return bootPromise !== null;
}

export function updateIntercomLanguage(language: string): void {
  if (!bootPromise) return;
  bootPromise.then(() => {
    (window as IntercomWindow).Intercom?.('update', { language_override: language });
  });
}

// Boots on demand and opens the messenger — safe to call from a click handler even when the SDK
// has not loaded yet (the boot is awaited before 'show').
export async function showIntercom(language: string): Promise<void> {
  await bootIntercom(language);
  (window as IntercomWindow).Intercom?.('show');
}
